<template>
  <EntitasForm mode="Ubah" module="Entitas"> </EntitasForm>
</template>

<script>
import EntitasForm from './form';

const EntitasUpdate = {
  name: 'EntitasUpdate',
  components: { EntitasForm },
};

export default EntitasUpdate;
</script>
